import { render, staticRenderFns } from "./ProductComments.vue?vue&type=template&id=fc3bb6d2&scoped=true"
import script from "./ProductComments.vue?vue&type=script&lang=js"
export * from "./ProductComments.vue?vue&type=script&lang=js"
import style0 from "./ProductComments.vue?vue&type=style&index=0&id=fc3bb6d2&prod&scoped=true&lang=css"
import style1 from "./ProductComments.vue?vue&type=style&index=1&id=fc3bb6d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3bb6d2",
  null
  
)

export default component.exports